// extracted by mini-css-extract-plugin
module.exports = {"Transfer":"Transfer_Transfer__2gOSu","input":"Transfer_input__2Bx_M","transfer":"Transfer_transfer__lww0o"};